import React from 'react';
import {utils, write} from 'xlsx';
import {saveAs} from 'file-saver';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import {Button} from '@mui/material';

function ExportToExcelButton({json_data, fileName}) {
  // Get current date
  const date = new Date();
  const dateString = `${date.getFullYear()}-${
    date.getMonth() + 1
  }-${date.getDate()}`;

  // Combine fileName and dateString
  const finalFileName = `${fileName}_Report_${dateString}.xlsx`;
  const exportJsonToExcel = () => {
    // Reorder the data to match the desired column order with proper header names
    const reorderedData = json_data.map((row) => {
      // Define the desired column order with proper header names - EXACT ORDER FROM IMAGE
      const columnMapping = {
        'Full Name': row.fullName || row.full_name || row.name,
        Phone: row.phone || row.phonenumber || row.phone_number,
        Age: row.age,
        'E-mail Address':
          row.email || row.emailaddress || row.email_address || row.e_mail,
        Country: row.country,
        Marks: row.marks || row.mark,
        MPC_4: row.MPC_4 || row.mpc4 || row.mpc_4,
        'Data Source': row.data_source || row.datasource,
        'Other Data': row.other_data || row.otherdata,
        'Integration Source': row.integration_source || row.integrationsource,
        error: row.error,
      };

      // Create new object with columns in desired order
      const reorderedRow = {};
      Object.keys(columnMapping).forEach((headerName) => {
        const value = columnMapping[headerName];
        if (value !== undefined && value !== null) {
          reorderedRow[headerName] = value;
        }
      });

      // Add any remaining columns that weren't in the mapping (like error messages) - EXCLUDE ID AND SYSTEM COLUMNS
      Object.keys(row).forEach((key) => {
        if (
          ![
            'fullName',
            'full_name',
            'name',
            'phone',
            'phonenumber',
            'phone_number',
            'age',
            'email',
            'emailaddress',
            'email_address',
            'e_mail',
            'country',
            'marks',
            'mark',
            'MPC_4',
            'mpc4',
            'mpc_4',
            'data_source',
            'datasource',
            'other_data',
            'otherdata',
            'integration_source',
            'integrationsource',
            'id',
            'created_at',
            'updated_at',
            'formId',
            'api_credential_id',
            'is_deleted',
            'is_new',
          ].includes(key)
        ) {
          reorderedRow[key] = row[key];
        }
      });

      return reorderedRow;
    });

    const ws = utils.json_to_sheet(reorderedData);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Sheet1');
    const wbout = write(wb, {bookType: 'xlsx', type: 'array'});
    const blob = new Blob([wbout], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, finalFileName);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        ml: 'auto',
        mt: '1rem',
      }}
    >
      <Button variant='contained' color='primary' onClick={exportJsonToExcel}>
        Export Error Report to Excel
      </Button>
    </Box>
  );
}
ExportToExcelButton.propTypes = {
  json_data: PropTypes.array.isRequired,
  fileName: PropTypes.string.isRequired,
};

export default ExportToExcelButton;
